import { css, Global } from '@emotion/react';

export default function GlobalStyles() {
  return (
    <Global
      styles={css`
        *,
        *::before,
        *::after {
          box-sizing: border-box;
        }

        html {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          height: 100%;
          text-rendering: optimizeLegibility;
        }

        body {
          background-color: var(--color-bg-base);
          color: var(--color-text-primary);
          font-family: var(--font-ui);
          font-size: var(--font-size-body);
          margin: 0;
          min-height: 100vh;
          padding: 0;
        }

        #root {
          min-height: 100vh;
        }

        img {
          height: auto;
          max-width: 100%;
        }

        a {
          color: var(--color-accent);
          text-decoration: none;
          transition: color var(--transition-base);

          &:hover {
            color: var(--color-text-primary);
          }

          &.disabled {
            pointer-events: none;
          }
        }

        button {
          appearance: none;
          background-color: transparent;
          border: 0;
          cursor: pointer;
          display: inline-block;
          font-family: inherit;
          line-height: 1;
          padding: 0;
        }

        ::selection {
          background: var(--color-accent-glow);
          color: var(--color-accent);
        }

        ::-webkit-scrollbar {
          width: 4px;
        }

        ::-webkit-scrollbar-track {
          background: var(--color-bg-base);
        }

        ::-webkit-scrollbar-thumb {
          background: var(--color-border-strong);
          border-radius: 2px;
        }
      `}
    />
  );
}
